var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReplyTrack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "g1g6qq9g6a"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#FFF",
    floodOpacity: 1,
    result: "floodOut"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "floodOut",
    in2: "SourceGraphic",
    operator: "atop",
    result: "compOut"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "compOut",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g1g6qq9g6a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3ECB6F",
    fillRule: "evenodd",
    d: "M.136 5.15L5.139.151c.143-.143.356-.185.545-.108.187.077.309.26.309.462v2.499h1.501c4.69 0 8.505 3.811 8.505 8.496 0 .222-.148.418-.362.479-.046.014-.092.02-.138.02-.169 0-.331-.086-.424-.235l-.15-.239c-1.358-2.173-3.795-3.524-6.36-3.524H5.993V10.5c0 .202-.122.385-.309.462-.188.076-.402.034-.545-.108L.136 5.857c-.195-.196-.195-.512 0-.707zm4.857 4.144V7.502c0-.276.224-.5.5-.5h3.072c2.36 0 4.626 1.008 6.217 2.706-.806-3.271-3.768-5.705-7.288-5.705H5.493c-.276 0-.5-.224-.5-.499V1.712L1.197 5.503l3.796 3.791z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplyTrack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/replyTrack.cf5256c2.svg";
export { ForwardRef as ReactComponent };